import React from "react";
import { TabsProvider } from "shared/components/Tabs/Tabs.Provider";

import Content009 from "./Content009";

export const Content009Entry = ({ payload }) => {
  const tabsEnabled = payload?.showListTabs ?? false;

  return (
    <TabsProvider tabsEnabled={tabsEnabled} defaultTab items={[]}>
      <Content009 payload={payload} />
    </TabsProvider>
  );
};

export default Content009Entry;
